import React, { useEffect } from 'react';
import { withTranslation } from '@wix/wix-i18n-config';
import ArenaOnBoardingPage from './ArenaOnboardingPage/ArenaOnboardingPage';
import queryString from 'query-string';

const REFERRAL_OF_SHOW_ONE_TAP_DISCLAIMER = 'oneTapLogin';

const ArenaOnBoardingController = props => {
  const { t, goToOnBoarding, goToLogin, goToArena, sendBi, referralAdditionalInfo, isLoggedIn = false } = props;

  const navigateWindow = (url, isNewWindow) => {
    if (isNewWindow) {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  };

  const goToTermOfUse = () => navigateWindow(t('Logo_Purchase_Page_Disclaimer1_terms_link'), true);
  const goToPrivacy = () => navigateWindow(t('Logo_Purchase_Page_Disclaimer1_privacy_link'), true);

  const sendAccessBiEvent = () => {
    const previousPage = referralAdditionalInfo && referralAdditionalInfo === 'mylogos' ? 'MyLogos' : 'LandingPage';
    sendBi('logoPageView', { origin: 'no', pageName: 'arenaSplitPage', previousPage });
  };

  useEffect(() => {
    sendAccessBiEvent();
  }, []);

  const referralInfo = queryString.parse(window.location.search).referralInfo ?? undefined;
  const shouldShowOneTapDisclaimer = referralInfo ? referralInfo === REFERRAL_OF_SHOW_ONE_TAP_DISCLAIMER : false;

  return (
    <ArenaOnBoardingPage
      t={t}
      shouldShowOneTapDisclaimer={shouldShowOneTapDisclaimer}
      loginInSplitscreen={!isLoggedIn}
      onTermOfUseClicked={goToTermOfUse}
      onPrivacyClicked={goToPrivacy}
      onGoToOnArena={() => {
        sendBi('arenaSplitPageArenaClick', { pageName: 'arenaSplitPage' });
        goToArena();
      }}
      onGoToOnBoarding={goToOnBoarding}
      onGoToLogin={goToLogin}
    />
  );
};

export default withTranslation()(ArenaOnBoardingController);
